import { render, staticRenderFns } from "./Mantenimiento.vue?vue&type=template&id=0fbde20d&scoped=true"
import script from "./Mantenimiento.vue?vue&type=script&lang=js"
export * from "./Mantenimiento.vue?vue&type=script&lang=js"
import style0 from "./Mantenimiento.vue?vue&type=style&index=0&id=0fbde20d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbde20d",
  null
  
)

export default component.exports